import { ApolloLink } from '@apollo/client';

export const diagnosticsLink = new ApolloLink((operation, forward) => {
  let diagnostics = JSON.parse(localStorage.getItem('askcodyDiagnostics'));

  if (diagnostics && diagnostics.exposeExceptions) {
    AddDirectivesIfNotExists(operation, 'exposeExceptions');
  }

  //if (diagnostics && diagnostics.enableLogging === true) {
  //  AddDirectivesIfNotExists(operation, 'enableLogging');
  //}

  return forward(operation);
});

const AddDirectivesIfNotExists = (operation, directive) => {
  let dirs = operation.query.definitions[0].directives;
  let containsExposeExceptions = false;

  dirs.forEach((dir) => {
    if (dir.name.value === directive) {
      containsExposeExceptions = true;
    }
  });

  if (!containsExposeExceptions) {
    const dir = {
      arguments: [],
      kind: 'Directive',
      name: {
        kind: 'Name',
        value: directive,
      },
    };

    dirs.push(dir);
  }
};
